// Copyright 1999-2025. WebPros International GmbH. All rights reserved.
import svg4everybody from 'svg4everybody';
const version = "3.43.2";
export * from './publicPath';
export { version };
export * from './utils';
export * from './components';
svg4everybody();